<template>
    <v-container style="margin: 60px 10%">
        <vueHeadful
        :title="this.$i18n.t('Menu.CapacitacionOficina') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12">
                <div class="textoMagazine" v-html="bienvenido.descripcionEs" v-if="getIdioma === 'es'" />
                <div class="textoMagazine" v-html="bienvenido.descripcionEn" v-else />
            </v-col>
            <v-col cols="12">
                <v-expansion-panels focusable accordion flat>
                    <v-expansion-panel v-for="(i, index) in secciones" :key="index">
                        <v-expansion-panel-header class="vietnam subtitle-1" v-if="getIdioma === 'es'">
                          <b>{{ i.tituloEs }}</b>
                          <template v-slot:actions>
                            <v-icon color="primary">$expand</v-icon>
                          </template>
                          </v-expansion-panel-header>
                        <v-expansion-panel-header class="vietnam subtitle-1" v-else>
                          <b>{{ i.tituloEn }}</b>
                          <template v-slot:actions>
                            <v-icon color="primary">$expand</v-icon>
                          </template>
                          </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-5 vietnam">
                            <div class="textoMagazine" v-html="i.descripcionEs" v-if="getIdioma === 'es'" />
                            <div class="textoMagazine" v-html="i.descripcionEn" v-else />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
export default {
  name: 'CapacitacionOficina',
  data () {
    return {
      bienvenido: [],
      secciones: []
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('manual').get().then(info => {
      this.bienvenido = info.data().bienvenido
      this.secciones = info.data().secciones
    })
  },
  computed: {
    ...mapGetters(['getIdioma'])
  }
}
</script>
